/** @format */

import { axiosInstance } from '@/common/application/context/Providers';
import { AxiosApiResponse } from '@common/types/api';
import { ElasticQueryOpts, ElasticResponse, ElasticSearchAfter } from '@common/types/elastic';
import { Nullable } from '@common/types/utils';

export interface IValue {
  hidden: boolean;
  mandatory: boolean;
}

export class FieldConfiguration {
  id: number;
  companyId: number;
  value: Record<string, IValue>;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;

  constructor(companyId: number, value: Record<string, IValue>) {
    this.companyId = companyId;
    this.value = value;
  }

  static list(query, sort, queryOpts: ElasticQueryOpts, size?: number, pit?: Nullable<string>, search_after?: Nullable<ElasticSearchAfter>): ElasticResponse<FieldConfiguration> {
    // Ensure this code is not ran by SSR!
    if (typeof window !== 'undefined') {
      return axiosInstance
        .get(`/api/v1/fieldconfigurations`, {
          params: {
            sequence_id: 1,
            pit,
            query,
            queryOpts: JSON.stringify(queryOpts),
            sort: JSON.stringify(sort),
            search_after: JSON.stringify(search_after),
            size,
          },
        })
        .then((res) => ({ ...res.data }));
    }
    throw new Error();
  }

  static addAllMissingCompanies(): AxiosApiResponse<Array<{ id: number }>> {
    return axiosInstance.post(`/api/v1/fieldconfigurations/addmissingcompanies`).then((res) => ({ ...res.data }));
  }

  static get(id: number): AxiosApiResponse<FieldConfiguration> {
    return axiosInstance.get(`/api/v1/fieldconfigurations/${id}`).then((res) => ({ ...res.data }));
  }

  static getByCompany(id: number): AxiosApiResponse<FieldConfiguration> {
    return axiosInstance.get(`/api/v1/company/${id}/fieldconfiguration`).then((res) => ({ ...res.data }));
  }

  static delete(id: number): Promise<Record<string, unknown>> {
    return axiosInstance.delete(`/api/v1/fieldconfigurations/${id}`).then((res) => ({ ...res.data }));
  }

  static undelete(id: number): Promise<Record<string, unknown>> {
    return axiosInstance.post(`/api/v1/fieldconfigurations/${id}/undelete`).then((res) => ({ ...res.data }));
  }

  static update(updatedFieldConfiguration: { value: Record<string, IValue> }, id: number): Promise<Record<string, unknown>> {
    return axiosInstance.patch(`/api/v1/fieldconfigurations/${id}`, { payload: updatedFieldConfiguration }).then((res) => ({ ...res.data }));
  }

  add(): Promise<Record<string, unknown>> {
    return axiosInstance
      .post(`/api/v1/fieldconfigurations`, {
        payload: {
          companyId: this.companyId,
          value: this.value,
        },
      })
      .then((res) => ({ ...res.data }));
  }
}
